import { render, staticRenderFns } from "./ValidationResults.vue?vue&type=template&id=2fa6e980&scoped=true"
import script from "./ValidationResults.vue?vue&type=script&lang=js"
export * from "./ValidationResults.vue?vue&type=script&lang=js"
import style0 from "./ValidationResults.vue?vue&type=style&index=0&id=2fa6e980&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6e980",
  null
  
)

export default component.exports